<template>
  <div v-loading="loading">
    <div v-if="tableData && tableData.length && !addOrEditingTables">
      <div class="mb-1" style="width: 100%">
        All Data
        <div class="action-links">
          <el-button
            type="danger"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="addNewRow('relationalTable')"
            >Relational Table</el-button
          >
          <el-button
            type="danger"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="addNewRow('dataTable')"
            >Data table Config</el-button
          >
        </div>
        <div style="margin-top: 20px">
          <el-collapse accordion>
            <el-collapse-item
              name="1"
              v-for="(item, index) in tableData"
              :key="index + '_collapse'"
              class="rule-collapse"
            >
              <template slot="title">
                <div style="width: 100%" class="ml-1">
                  {{ item.name }}
                  <div class="action-links">
                    <el-link
                      :underline="false"
                      type="primary"
                      class="mr-1"
                      @click.stop="editRule(index)"
                      ><i class="el-icon-edit"></i>
                    </el-link>
                    <el-link
                      type="danger"
                      :underline="false"
                      @click.stop="onDelete(index)"
                      ><i class="el-icon-delete"></i>
                    </el-link>
                  </div>
                </div>
              </template>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div style="margin-top: 20px" class="action-links">
          <el-button type="primary" plain size="mini" @click="saveAllTables()"
            >Save</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="rule-container"
      v-loading="editLoading"
      :element-loading-text="loadingText"
      v-else-if="addOrEditingTables"
    >
      <!-- <template slot-scope="scope"> -->
      <el-row>
        <el-col :span="24">
          Table Name
          <el-input
            v-model="currentTable.name"
            placeholder="Table name"
            :disabled="checkIsDisabled()"
            class="mb-1"
            size="mini"
            style="width: 80%"
            @change="checkRuleName(currentTable.name)"
          >
          </el-input>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px" v-if="current_type == 'relationalTable'">
        <el-col :span="12">
          Select Entity
          <el-select
            v-model="currentTable.entity_id"
            placeholder="Select Entity"
            filterable
            @change="getEntityFilters"
            size="mini"
          >
            <el-option
              v-for="entity in allEntitiesData"
              :key="entity._id"
              :label="entity.name"
              :value="entity._id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          Select Type
          <el-select
            v-model="currentTable.type"
            filterable
            size="mini"
            :disabled="!currentTable.entity_id"
            @change="handleTypeChange()"
          >
            <el-option
              v-for="(item, i) in tableTypes"
              :key="item.value + i"
              :label="item.label"
              :value="item.value"
              :disabled="isPdfOptionDisabled(item.value)"
              >{{ item.label }}</el-option
            >
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px" v-if="current_type == 'relationalTable'">
        <el-col :span="12">
          Select Filter
          <el-select
            v-loading="filterLoading"
            v-model="currentTable.filters"
            clearable
            size="mini"
          >
            <el-option
              v-for="filter in currentEntityFilters"
              :key="filter._id"
              :label="filter.filter_name"
              :value="filter._id"
              >{{ filter.filter_name }}</el-option
            >
          </el-select>
        </el-col>
        <el-col :span="12">
          Select Fields
          <el-select
            v-loading="filterLoading"
            v-model="currentTable.selectedFields"
            clearable
            filterable
            collapse-tags
            multiple
            :disabled="currentTable.type != 'email_body'"
            size="mini"
            :multiple-limit="12"
          >
            <el-option
              v-for="(field, i) in selectedEntityFields"
              :key="field._id + i"
              :label="field.label"
              :value="field.template_key"
              >{{ field.label }}</el-option
            >
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px" v-else>
        <el-col :span="12">
          Select Data Table
          <el-select
            v-model="currentTable.data_table_key"
            clearable
            @change="handleDataTableChange(currentTable.data_table_key)"
            size="mini"
          >
            <el-option
              v-for="field in dataTableFields"
              :key="field.template_key"
              :label="field.label"
              :value="field.template_key"
              >{{ field.label }}</el-option
            >
          </el-select>
        </el-col>
        <el-col :span="12">
          <div
            v-if="
              currentTable.data_table_key &&
              mentionableDataTableFields &&
              mentionableDataTableFields.length
            "
          >
            <el-button @click="configureDataTable" size="mini">
              configure a row
            </el-button>
            <p
              v-if="!currentTable.data_table_content"
              style="font-size: 10px; color: red; font-weight: 700"
            >
              Please Configure row
            </p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="mt-10"
        v-if="current_type == 'dataTable' && currentTable.data_table_key"
      >
        <el-col>
          <el-link
            :underline="false"
            type="primary"
            @click="openDataTableFiltersModal"
          >
            Get only filtered data
          </el-link>
        </el-col>
      </el-row>
      <div class="action-footer">
        <el-button size="mini" @click="cancelNewRule">Cancel</el-button>
        <el-button
          type="primary"
          size="mini"
          :disabled="checkSaveDisabled()"
          @click="saveNewTable"
          >Add</el-button
        >
      </div>
      <!-- </template> -->
    </div>
    <div v-else-if="!tableData.length" class="empty-alert">
      <div>
        <img src="@/assets/img/nodata2.svg" />
      </div>
      <div>
        <el-button
          type="danger"
          icon="el-icon-plus"
          plain
          @click="addNewRow('relationalTable')"
          class="add-rule"
          size="mini"
          >Add Relational Table</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-plus"
          plain
          @click="addNewRow('dataTable')"
          class="add-rule"
          size="mini"
          >Configure Data Table</el-button
        >
      </div>
    </div>
    <dialog-component
      :title="'Configure Single Row'"
      :visible="ckEditorDialog"
      :containerWidth="'50%'"
      @before-close="resetPopUp"
    >
      <div style="padding: 20px 10px">
        <CkEditorOffline
          :config="editorConfig"
          v-model="currentTable.data_table_content"
          :key="editorKey"
        >
        </CkEditorOffline>
      </div>
    </dialog-component>
    <dialog-component
      :visible.sync="addDataTableStepFilters"
      title="Add filters"
      @before-close="resetDataTableFilters"
      :containerMinWidth="getIsMobile ? '100%' : '50%'"
    >
      <!-- <div class="p-10"> -->
      <div class="p-10">
        <el-row>
          <div>
            <el-select
              v-model="dataTablefiltersQuery"
              placeholder="Query type"
              size="mini"
            >
              <el-option
                v-for="op in [
                  { name: 'All', value: 'AND' },
                  { name: 'Any one', value: 'OR' },
                ]"
                :key="op.name + '_query_type'"
                :label="op.name"
                :value="op.value"
              >
              </el-option>
            </el-select>
            conditions need to be satisfied
          </div>
          <el-link
            type="primary"
            icon="el-icon-plus"
            class="float-right"
            :underline="false"
            @click="addFilter"
            >Add filter</el-link
          >
        </el-row>
        <el-row
          v-for="(filter, i) in dataTablefilters"
          :key="i + '_filters_field'"
          :gutter="10"
          class="mt-1"
        >
          <el-col :span="6">
            <el-select
              placeholder="Field"
              v-model="filter.selectField"
              @change="
                (changedValue) =>
                  checkCurrentFieldData(
                    changedValue,
                    filter,
                    allFieldsWithDataTable
                  )
              "
            >
              <el-option
                v-for="(op, i) in allFieldsWithDataTable"
                :key="i + '_filter_field'"
                :value="op.key"
                :label="op.label"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-select
              v-model="filter.operator"
              :disabled="!filter.selectField"
              placeholder="Operator"
            >
              <el-option
                v-for="(operator, index) of getCurrentFieldOperators(filter)"
                :key="index + '_operator'"
                :label="operator.title"
                :value="operator.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="5"
            v-if="filter.operator != 'exists' && filter.operator != 'notexists'"
          >
            <el-select
              v-model="filter.data_source"
              placeholder="Data source"
              :disabled="!filter.operator"
            >
              <el-option
                v-for="(source, index) of allowedDataSources(filter)"
                :key="index"
                :label="source"
                :value="source"
              ></el-option>
            </el-select>
          </el-col>
          <el-col
            :span="6"
            v-if="filter.operator != 'exists' && filter.operator != 'notexists'"
          >
            <template v-if="filter.data_source == 'TEMPLATE'">
              <el-select
                placeholder="Resource field"
                v-model="filter.value_field"
                clearable
              >
                <el-option
                  v-for="(option, index) of getRelatedFields(filter)"
                  :value="option.key"
                  :label="option.label"
                  :key="index"
                ></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-select
                v-if="
                  filter.inputType == 'SELECT' &&
                  filter.data_source == 'OPTIONS'
                "
                placeholder="Resource field"
                v-model="filter.value"
                clearable
                multiple
              >
                <el-option
                  v-for="(option, index) of getSelectOptions(
                    filter,
                    allFieldsWithDataTable
                  )"
                  :value="option"
                  :label="option"
                  :key="index + '_options'"
                ></el-option>
              </el-select>
              <el-select
                v-else-if="
                  filter.inputType == 'SELECT' && filter.data_source == 'VALUE'
                "
                placeholder="Value"
                v-model="filter.value"
                multiple
                clearable
                filterable
                collapse-tags
                default-first-option
                allow-create
              >
                <el-option
                  v-for="(option, index) of filter.value"
                  :value="option"
                  :label="option"
                  :key="index + '_options'"
                ></el-option>
              </el-select>
              <el-input
                v-model="filter.value"
                v-else-if="filter.data_type == 'STRING'"
                :disabled="!filter.data_source"
              ></el-input>
              <el-input-number
                v-else-if="filter.data_type == 'NUMBER'"
                v-model="filter.value"
                :controls="false"
                placeholder="value"
                :disabled="!filter.data_source"
              ></el-input-number>
            </template>
          </el-col>
          <el-col :span="2">
            <el-link
              class="mt-1 ml-2"
              type="danger"
              :underline="false"
              @click="removeFilter(i)"
            >
              <i class="el-icon-delete"></i>
            </el-link>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDataTableFilters">Close</el-button>
        <el-button
          type="primary"
          :disabled="checkFilterDisable"
          @click="saveFilters"
          >Save</el-button
        >
      </span>
      <!-- </div> -->
    </dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EntityHelper from "@/mixins/EntitiesHelper";
import TemplateBuilderHelper from "@/mixins/templateBuilderHelper.js";
import { ckEditorConfig } from "@/assets/data/ckeditor_config.ts";
import automationHelper from "@/mixins/AutomationHelper.js";

// import { bus } from "../../main";
export default {
  name: "EmailRelationalDataTableConfig",
  props: ["data", "allEntitiesData", "fields", "allCompanyDataFields"],
  mixins: [EntityHelper, TemplateBuilderHelper, automationHelper],
  async mounted() {
    this.getNeccessaryDetails();
  },
  data() {
    return {
      loading: false,
      current_type: "",
      fieldsObject: {},
      dataTableFields: [],
      editorConfig: JSON.parse(JSON.stringify(ckEditorConfig)),
      ckEditorDialog: false,
      mentionableDataTableFields: [],
      currentTable: {
        name: "",
        entity_id: "",
        filters: "",
        selectedFields: [],
        type: "email_body",
        data_table_key: "",
        data_table_content: "",
      },
      addDataTableStepFilters: false,
      dataTablefilters: [],
      dataTablefiltersQuery: "AND",
      globalVariablesList: [],
      currentTableIndex: -1,
      addOrEditingTables: false,
      currentEntityFilters: [],
      selectedEntityFields: [],
      filterLoading: false,
      tableTypes: [
        {
          label: "Table in Email Body",
          value: "email_body",
        },
        {
          label: "Attachment as Excel",
          value: "attachment_as_excel",
        },
        {
          label: "Attachment as Pdf",
          value: "attachment_as_pdf",
        },
      ],
      editLoading: false,
      loadingText: "",
      tableData: [],
      selectedEntity: null,
      editorKey: 1,
    };
  },
  computed: {
    ...mapGetters("auth", [
      "getDefaultDateFormat",
      "getAuthenticatedUser",
      "getUserTypeList",
      "getUserType",
      "getCompanyUsers",
    ]),
    ...mapGetters("navigationOpen", ["getIsMobile", "getIsRSOpen"]),
    ...mapGetters("users", ["getUsersList"]),
    ...mapGetters("entities", ["getEntityRecordsForTable", "getAllEntities"]),
    ...mapGetters("companyTemplates", [
      "getSingleCompanyTemplate",
      "getAllCompanyTemplatesData",
      "getAllCompanyTemplates",
    ]),
    ...mapGetters("filters", [
      "getAllEntityFilters",
      "getCreateNewFilter",
      "getUpdateFilterStatus",
      "getDeleteFilterStatus",
      "getCreateNewFilterError",
      "getUpdateFilterError",
      "getDeleteFilterErros",
    ]),
  },
  components: {
        CkEditorOffline :() => import("@/components/CkEditor.vue"),
  },
  methods: {
    cancelNewRule() {
      this.resetCurrentTable();
      this.addOrEditingTables = false;
    },
    openDataTableFiltersModal() {
      this.dataTablefilters = [];
      let currentDataTableField =
        this.fieldsObject[this.currentTable.data_table_key];
      this.dataTablefilters = this.currentTable?.data_table_filters || [];
      this.dataTablefiltersQuery =
        this.currentTable?.data_table_filter_query || "AND";
      let allowedFields = [
        "NUMBER",
        "CURRENCY",
        "FORMULA",
        "AGGREGATE_FUNCTION",
        "SELECT",
      ];
      this.allFieldsWithDataTable = (
        currentDataTableField?.data_table_columns || []
      )
        .filter((e) => e.key && allowedFields.indexOf(e.inputType) !== -1)
        .map((dt) => {
          let e = JSON.parse(JSON.stringify(dt));
          e.data_type = this.getTypeFromInputType(e.result_type);
          return e;
        });
      this.addDataTableStepFilters = true;
    },
    saveFilters() {
      this.$set(this.currentTable, "data_table_filters", this.dataTablefilters);
      this.$set(
        this.currentTable,
        "data_table_filter_query",
        this.dataTablefiltersQuery
      );
      console.log("this.dataTablefilters", this.dataTablefilters);
      this.resetDataTableFilters();
    },
    checkSaveDisabled() {
      if (!this.currentTable.name) {
        return true;
      }
      if (
        this.current_type == "dataTable" &&
        (!this.currentTable.data_table_key ||
          !this.currentTable.data_table_content)
      ) {
        return true;
      } else if (
        this.currentTable.typee == "relationalTable" &&
        (!this.currentTable.entity_id ||
          (!this.currentTable.typee == "dataTable" &&
            this.currentTable.type == "email_body" &&
            !this.currentTable.selectedFields?.length))
      ) {
        return true;
      }
      return false;
    },
    handleDataTableChange(key, isEdit = false) {
      this.getDataTableMentionableFields(key);
      if (!isEdit) this.currentTable.data_table_content = "";
    },
    getNeccessaryDetails() {
      this.tableData = [...this.data];
      this.fieldsObject = {};
      this.dataTableFields = [];
      (this.fields || []).map((e) => {
        if (["DATA_TABLE","ENTITY_TABLE"].includes(e.inputType)) {
          this.dataTableFields.push(e);
        }
        this.fieldsObject[e.template_key] = e;
      });
      this.editorConfig.mentions = [
        {
          feed: this.dataFeed,
          itemTemplate:
            '<li data-id="{id}">' +
            '<strong class="label">{label}</strong>' +
            "</li>",
          outputTemplate: (item) => {
            if (
              item.input_type == "IMAGE" ||
              item.inputType == "IMAGE" ||
              item.input_type == "GIF"
            ) {
              return `<img alt="${item.label}" 
                            src="https://app-esigns-io.s3.amazonaws.com/ck_editor_assets/MicrosoftTeams-image_8-1716639572596.png?field=[[${item.label}]]" 
                            style="width: 80px;"
                            title="${item.label}" />`;
            } else {
              return `<span>&nbsp;</span><span>[[${item.label}]]</span><span>&nbsp;</span>`;
            }
          },
          minChars: 0,
          convertTo: function (item) {
            return {
              template_key: item.label,
            };
          },
        },
        {
          feed: this.companyDataFeed,
          marker: "#",
          itemTemplate:
            '<li data-id="{id}">' +
            '<strong class="label">{label}</strong>' +
            "</li>",
          outputTemplate:
            "<span>&nbsp;</span><strong>(({id}))</strong><span>&nbsp;</span>",
          minChars: 0,
        },
      ];
      this.editorConfig["id"] = "emailRelationalDataTableConfig";
    },
    addNewRow(type) {
      this.resetCurrentTable();
      this.currentTable["typee"] = type;
      this.currentTableIndex = -1;
      this.addOrEditingTables = true;
      this.current_type = type;
    },
    async editRule(index) {
      this.loadingText = "Fetching data...";
      this.addOrEditingTables = true;
      this.editLoading = true;
      let dt = JSON.parse(JSON.stringify(this.tableData[index]));
      if (!dt.typee) {
        this.currentTable.typee = "relationalTable";
        dt.typee = "relationalTable";
      } else {
        this.currentTable.typee = dt.typee;
      }

      this.current_type = dt.typee;
      this.currentTable.name = dt.name;
      if (this.currentTable.typee == "dataTable") {
        this.currentTable.data_table_key = dt.data_table_key;
        this.currentTable.data_table_content = dt.data_table_content;
        this.currentTable.data_table_filter_query = dt.data_table_filter_query;
        this.currentTable.data_table_filters = dt.data_table_filters;
        this.handleDataTableChange(dt.data_table_key, true);
      } else {
        await this.getEntityFilters(dt.entity_id);
        this.currentTable.filters = dt.filters;
        this.currentTable.selectedFields = [...dt.selectedFields];
        this.currentTable.entity_id = dt.entity_id;
        this.currentTable.type = dt.type;
      }
      this.currentTableIndex = index;
      this.editLoading = false;
    },
    onDelete(index) {
      this.$confirm("Are you sure to delete the Table?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteRule(index);
      });
    },
    deleteRule(index) {
      this.addOrEditingTables = false;
      this.tableData.splice(index, 1);

      if (!this.tableData?.length) {
        this.resetCurrentTable();
        this.$emit("save-all-tables", this.tableData);
      }
    },

    checkRuleName(event) {
      let ruleNameCheck = this.tableData.filter(
        (el) => el && el.name === event
      );
      if (ruleNameCheck && ruleNameCheck?.length) {
        this.$message.error("Name already exists!");
        this.currentTable.name = "";
      } else if (/^\s*$/.test(event)) {
        this.$message.error("name should not be empty or contain only spaces!");
        this.currentTable.name = "";
      }
    },
    getDataTableMentionableFields(key) {
      this.mentionableDataTableFields = [];
      let selectedDataTable = this.fieldsObject[key];
      if (selectedDataTable?.data_table_columns?.length) {
        this.mentionableDataTableFields =
          selectedDataTable.data_table_columns.map((e) => {
            e.id = e.key;
            return e;
          });
      }
    },
    configureDataTable() {
      const regex = /\[\[(.*?)\]\]/g;
      this.getDataTableMentionableFields(this.currentTable.data_table_key);
      if (this.currentTable.data_table_content)
        this.currentTable.data_table_content = this.parseEmailTemplate(
          regex,
          this.currentTable.data_table_content,
          this.mentionableDataTableFields,
          true
        );
      this.editorKey = this.editorKey + 1;
      this.ckEditorDialog = true;
    },
    resetPopUp() {
      this.ckEditorDialog = false;
      const regex = /\[\[(.*?)\]\]/g;
      if (this.currentTable.data_table_content) {
        this.currentTable.data_table_content = this.parseEmailTemplate(
          regex,
          this.currentTable.data_table_content,
          this.mentionableDataTableFields
        );
      }
    },
    dataFeed(opts, callback) {
      var matchProperty = "label",
        data = this.mentionableDataTableFields.filter(function (item) {
          return (
            item[matchProperty]
              .toLowerCase()
              .indexOf(opts.query.toLowerCase()) !== -1
          );
        });
      data = data.sort(function (a, b) {
        return a[matchProperty].localeCompare(b[matchProperty], undefined, {
          sensitivity: "accent",
        });
      });
      callback(data);
    },
    companyDataFeed(opts, callback) {
      var matchProperty = "label",
        data = this.allCompanyDataFields.filter(function (item) {
          return (
            item[matchProperty]
              .toLowerCase()
              .indexOf(opts.query.toLowerCase()) !== -1
          );
        });
      data = data.sort(function (a, b) {
        return a[matchProperty].localeCompare(b[matchProperty], undefined, {
          sensitivity: "accent",
        });
      });
      callback(data);
    },
    saveNewTable() {
      this.addOrEditingTables = false;
      this.currentTable = {
        ...this.currentTable,
        typee: this.current_type,
      };
      if (this.currentTableIndex == -1) {
        this.tableData.push(this.currentTable);
      } else {
        this.tableData[this.currentTableIndex] = { ...this.currentTable };
      }
    },
    resetCurrentTable() {
      this.currentTable = {
        name: "",
        entity_id: "",
        filters: "",
        selectedFields: [],
        type: "email_body",
        content: "",
      };
      this.currentEntityFilters = [];
      this.selectedEntityFields = [];
    },
    async getEntityFilters(entity_id) {
      this.loadingText = "Fetching filters";
      this.filterLoading = true;
      this.selectedEntity = this.allEntitiesData.find(
        (e) => e._id == entity_id
      );
      this.currentTable["filters"] = "";
      this.currentTable["type"] = "email_body";
      this.currentTable["selectedFields"] = [];
      if (this.currentTable.document_id) {
        this.currentTable["document_id"] = "";
      }
      await this.$store.dispatch("filters/fetchAllEntityFilters", {
        entityId: entity_id,
      });
      this.currentEntityFilters = [];
      if (this.getAllEntityFilters) {
        this.currentEntityFilters = this.getAllEntityFilters;
      }
      this.currentTable["selectedFields"] = [];
      this.selectedEntityFields = await this.fetchEntityDetails(
        entity_id,
        true,
        true
      );
      this.selectedEntityFields = this.selectedEntityFields.filter(
        (e) =>
          e.properties?.filed_content != "Hide" &&
          e.input_type != "DATA_TABLE" &&
          (e.type != "CONTENT" ||
            (e.type == "CONTENT" && e.inputType == "IMAGE"))
      );
      this.filterLoading = false;
    },
    saveAllTables() {
      this.$emit("save-all-tables", this.tableData);
    },
    checkIsDisabled() {
      return this.currentTableIndex == -1 ? false : true;
    },
    handleTypeChange() {
      if (this.currentTable.type == "attachment_as_pdf") {
        this.currentTable["document_id"] =
          this.selectedEntity.export_printing_document;
        this.currentTable.selectedFields = [];
      }
    },
    isPdfOptionDisabled(type) {
      if (
        type == "attachment_as_pdf" &&
        !this.selectedEntity?.export_printing_document
      ) {
        return true;
      }
      return false;
    },
  },

  //   created() {
  //     bus.$on("form-rule-dialog-closed", (data) => {
  //       if (data) {
  //         if (this.tableData.length) {
  //           //do action when template rules exist
  //         } else {
  //           this.addOrEditingTables = false;
  //           this.currentTable = {
  //             name: "",
  //             entity_id: "",
  //             filters: "",
  //             selectedFields: [],
  //             type : "email_body"
  //           };
  //         }
  //       }
  //     });
  //   },
};
</script>

<style lang="scss" scoped>
.action-links {
  float: right !important;
}
.small-input {
  width: 180px;
}

.rule-collapse {
  border: 1px solid #e4e7ed;
  border-radius: 3px;
}

.empty-alert {
  text-align: center !important;

  img {
    width: 100px;
    margin-bottom: 10px;
  }

  .add-rule {
  }
}

.rule-row {
  display: flex !important;
  background: #f2f6fc;
  height: 55px;

  .rule-inner-row {
    display: grid;
    margin: auto;
    margin-right: 25px;
    margin-left: 25px;
    grid-template-columns: auto auto auto auto;
  }
}

.action-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.rule-preview {
  padding: 10px;
  font-size: 12px;

  img {
    width: 25px;
  }
}

.el-date {
}
</style>
